"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var axios_1 = require("axios");
var vue_infinite_loading_1 = require("vue-infinite-loading");
var ExerciseCards_1 = require("../../components/exercise_cards/ExerciseCards");
var ExerciseIndex = /** @class */ (function (_super) {
    __extends(ExerciseIndex, _super);
    function ExerciseIndex() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.categories = [];
        _this.exercisesView = [];
        _this.scrollOptions = {
            duration: 500,
            offset: 0,
            easing: 'easeInOutCubic',
        };
        _this.offsetTop = 0;
        _this.page = 0;
        _this.complete = false;
        _this.maxLength = 0;
        return _this;
    }
    /**
     *  使わない！！
     */
    ExerciseIndex.prototype.refs = function () {
        return this.$refs;
    };
    ExerciseIndex.prototype.onScroll = function (e) {
        var document_ = e.target;
        if (document_.scrollingElement) {
            this.offsetTop = document_.scrollingElement.scrollTop;
        }
        else if (document_.documentElement) {
            this.offsetTop = document_.documentElement.offsetTop;
        }
        else {
            this.offsetTop = document_.body.offsetTop;
        }
    };
    Object.defineProperty(ExerciseIndex.prototype, "isscrollButtomShow", {
        /**
         *  100px 以上スクロールしたら、Button を表示する。
         */
        get: function () {
            return this.offsetTop > 100;
        },
        enumerable: true,
        configurable: true
    });
    ExerciseIndex.prototype.infiniteHandle = function ($state) {
        if (this.complete) {
            // 表示するデータが無くなった場合
            $state.complete();
        }
        else {
            this.loadMore().then(function (res) {
                if (!res) {
                    alert('エラーが発生しました。');
                    $state.complete();
                }
                $state.loaded();
            });
        }
    };
    ExerciseIndex.prototype.loadMore = function () {
        var self_ = this;
        return new Promise(function (resolve) {
            self_.$ga.event({
                eventCategory: '【STOP_COVID_19】検索実行',
                eventAction: "\u3010STOP_COVID_19\u3011\u691C\u7D22\u5B9F\u884C: categories:[" + self_.categories.join(',') + "] page: " + self_.page,
                eventLabel: '【STOP_COVID_19】検索実行'
            });
            var url_ = self_.$invokeUrlMaker.create('exercise/list');
            var params = JSON.stringify({
                categories: self_.categories,
                page: self_.page
            });
            axios_1.default.post(url_, params).then(function (res) {
                var data = res.data;
                self_.exercisesView = self_.exercisesView.concat(data.data);
                self_.page = Number(data.page) + 1;
                self_.complete = Boolean(data.complete);
                self_.maxLength = data.totalCount;
                resolve(true);
            }).catch(function (err) {
                resolve(false);
            });
        });
    };
    ExerciseIndex.prototype.beforeCreate = function () {
        document.title = "運動マニュアル検索 | 自宅でできる介護リハビリ - リハプラン";
        document.querySelector("meta[property='og:title']").setAttribute('content', "運動マニュアル検索 | 自宅でできる介護リハビリ - リハプラン");
        document.querySelector("meta[name='description']").setAttribute('content', "リハプランの特設サイト「自宅でできる介護リハビリ」の運動マニュアル検索はこちらです。約2,200種類、500セットの運動マニュアルを、さまざまな運動目標・目的から探すことができます。");
        document.querySelector("meta[property='og:description']").setAttribute('content', "リハプランの特設サイト「自宅でできる介護リハビリ」の運動マニュアル検索はこちらです。約2,200種類、500セットの運動マニュアルを、さまざまな運動目標・目的から探すことができます。");
        document.querySelector("meta[name='keywords']").setAttribute('content', "自宅でできる,介護リハビリ,運動マニュアル,リハプラン");
        document.querySelector("link[rel='canonical']").setAttribute('href', "https://rehaplan.jp/keeprehab/index");
    };
    /**
     * Mounted 時の処理。
     * ログインしていなければ、ログイン画面にリダイレクト。
     */
    ExerciseIndex.prototype.mounted = function () {
        this.init();
    };
    ExerciseIndex.prototype.init = function () {
        var self_ = this;
        if (!self_.$login.isSignIn()) {
            this.$router.push({ path: '/keeprehab/login' });
        }
        this.$ga.set('dimension1', this.$login.getCurrentUser());
        this.resetSearch();
        this.$emit('back-icon-hide');
        // Google Analitics;
        this.$ga.event({
            eventCategory: '【STOP_COVID_19】検索画面に遷移',
            eventAction: "\u3010STOP_COVID_19\u3011\u691C\u7D22\u753B\u9762\u306B\u9077\u79FB",
            eventLabel: '【STOP_COVID_19】検索画面に遷移'
        });
    };
    ExerciseIndex.prototype.resetSearch = function () {
        this.page = 0;
        this.complete = false;
        this.exercisesView = [];
        // stateChanger は、これでしか呼べない。。
        if (this.refs().InfiniteLoading) {
            this.refs().InfiniteLoading.stateChanger.reset();
        }
    };
    ExerciseIndex.prototype.routeChange = function () {
        this.init();
    };
    __decorate([
        vue_property_decorator_1.Watch('categories')
    ], ExerciseIndex.prototype, "resetSearch", null);
    __decorate([
        vue_property_decorator_1.Watch('$route')
    ], ExerciseIndex.prototype, "routeChange", null);
    ExerciseIndex = __decorate([
        vue_property_decorator_1.Component({
            components: {
                ExerciseCards: ExerciseCards_1.default,
                InfiniteLoading: vue_infinite_loading_1.default
            }
        })
    ], ExerciseIndex);
    return ExerciseIndex;
}(vue_property_decorator_1.Vue));
exports.default = ExerciseIndex;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/exercise/Index.vue
// module id = dYRy
// module chunks = 1